// 省份名称匹配工具

// 省份名称映射表 - 处理各种可能的名称变体
const PROVINCE_NAME_VARIANTS: Record<string, string[]> = {
  '北京市': ['北京', '北京市'],
  '天津市': ['天津', '天津市'],
  '河北省': ['河北', '河北省'],
  '山西省': ['山西', '山西省'],
  '内蒙古自治区': ['内蒙古', '内蒙古自治区', '内蒙'],
  '辽宁省': ['辽宁', '辽宁省'],
  '吉林省': ['吉林', '吉林省'],
  '黑龙江省': ['黑龙江', '黑龙江省'],
  '上海市': ['上海', '上海市'],
  '江苏省': ['江苏', '江苏省'],
  '浙江省': ['浙江', '浙江省'],
  '安徽省': ['安徽', '安徽省'],
  '福建省': ['福建', '福建省'],
  '江西省': ['江西', '江西省'],
  '山东省': ['山东', '山东省'],
  '河南省': ['河南', '河南省'],
  '湖北省': ['湖北', '湖北省'],
  '湖南省': ['湖南', '湖南省'],
  '广东省': ['广东', '广东省'],
  '广西壮族自治区': ['广西', '广西壮族自治区', '广西省'],
  '海南省': ['海南', '海南省'],
  '重庆市': ['重庆', '重庆市'],
  '四川省': ['四川', '四川省'],
  '贵州省': ['贵州', '贵州省'],
  '云南省': ['云南', '云南省'],
  '西藏自治区': ['西藏', '西藏自治区', '西藏省'],
  '陕西省': ['陕西', '陕西省'],
  '甘肃省': ['甘肃', '甘肃省'],
  '青海省': ['青海', '青海省'],
  '宁夏回族自治区': ['宁夏', '宁夏回族自治区', '宁夏省'],
  '新疆维吾尔自治区': ['新疆', '新疆维吾尔自治区', '新疆省'],
  '香港特别行政区': ['香港', '香港特别行政区', '香港特区'],
  '澳门特别行政区': ['澳门', '澳门特别行政区', '澳门特区'],
  '台湾省': ['台湾', '台湾省']
};

// 创建反向映射表：从各种变体名称映射到标准名称
const VARIANT_TO_STANDARD: Record<string, string> = {};
Object.entries(PROVINCE_NAME_VARIANTS).forEach(([standard, variants]) => {
  variants.forEach(variant => {
    VARIANT_TO_STANDARD[variant] = standard;
  });
});

/**
 * 标准化省份名称
 * @param name 输入的省份名称
 * @returns 标准化后的省份名称
 */
export const normalizeProvinceName = (name: string): string => {
  if (!name) return '';
  
  const trimmed = name.trim();
  
  // 直接匹配
  if (VARIANT_TO_STANDARD[trimmed]) {
    return VARIANT_TO_STANDARD[trimmed];
  }
  
  // 模糊匹配 - 去掉常见后缀
  const withoutSuffix = trimmed
    .replace(/[省市区]$/, '')
    .replace(/自治区$/, '')
    .replace(/特别行政区$/, '')
    .replace(/壮族|回族|维吾尔$/, '');
  
  if (VARIANT_TO_STANDARD[withoutSuffix]) {
    return VARIANT_TO_STANDARD[withoutSuffix];
  }
  
  // 如果都没匹配到，返回原名称
  return trimmed;
};

/**
 * 查找匹配的省份
 * @param mapProvinceName 地图中的省份名称
 * @param gameProvinces 游戏中的省份列表
 * @returns 匹配的省份对象或null
 */
export const findMatchingProvince = (mapProvinceName: string, gameProvinces: any[]) => {
  if (!mapProvinceName || !gameProvinces) return null;
  
  // 标准化地图中的省份名称
  const normalizedMapName = normalizeProvinceName(mapProvinceName);
  
  // 在游戏省份中查找匹配
  return gameProvinces.find(province => {
    if (!province.name) return false;
    
    const normalizedGameName = normalizeProvinceName(province.name);
    return normalizedGameName === normalizedMapName;
  });
};

/**
 * 获取所有支持的省份名称变体
 */
export const getAllProvinceVariants = (): string[] => {
  return Object.keys(VARIANT_TO_STANDARD);
};

/**
 * 检查是否为有效的省份名称
 */
export const isValidProvinceName = (name: string): boolean => {
  return !!VARIANT_TO_STANDARD[normalizeProvinceName(name)];
};
